
// 不进行上报的异常
export class NoReportError extends Error {
  static tag = '--no_report_error'; // 标识，用于上报时过滤错误

  constructor(error: Error | string) {
    if (typeof error === 'string') {
      super(`${error} ${NoReportError.tag}`);
    } else {
      super(`${error.message} ${NoReportError.tag}`);
      this.name = error.name;
    }
  }
}
